import React, { useEffect, useState } from "react";
import { Dropdown, Spinner } from "react-bootstrap";
import "react-toastify/dist/ReactToastify.css";
import { RiMore2Fill } from "react-icons/ri";
import { FaDownload, FaTrash } from "react-icons/fa";
import {
  GrDocument,
  GrDocumentSound,
  GrDocumentTxt,
  GrDocumentVideo,
} from "react-icons/gr";
import { formatFileSize } from "../../../utilities/ext-function";
import ImagePopup from "../../../components/imagePopup";
import { API_URL } from "../../../utilities/url";

const CardList = ({ cards, loading, onHandleDelete }) => {
  const [prevHeight, setPrevHeight] = useState("auto");

  // Image Popup
  const [isOpen, setIsOpen] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const openModal = (url) => {
    setImageUrl(url);
    setIsOpen(true);
  };
  const closeModal = () => setIsOpen(false);

  useEffect(() => {
    if (!loading && cards.length > 0) {
      const cardsPerRow = 6;
      const rowHeight = 150;
      const minHeight = 260;
      const rows = Math.ceil(cards.length / cardsPerRow);
      setPrevHeight(`${Math.max(rows * rowHeight, minHeight)}px`);
    }
  }, [loading, cards]);

  const handleDownload = async (fileUrl) => {
    document.body.click();
    const proxyUrl =
      API_URL + `proxy-media-download?url=${encodeURIComponent(fileUrl)}`;
    window.location.href = proxyUrl;
  };

  const handleDelete = (id, filesize) => {
    document.body.click();
    onHandleDelete(id, filesize);
  };

  return (
    <>
      {!loading ? (
        cards.length > 0 ? (
          <div
            className="d-flex flex-wrap"
            style={{
              gap: "1.25rem",
              marginRight: "-20px",
              minHeight: prevHeight,
            }}
          >
            {cards.map((card, index) => (
              <div key={index} className="custom-coloum folder-card">
                <div className="card card-list shadow-lg mb-0">
                  <div
                    //   onClick={() => handleCardClick(card)}
                    className="card-body"
                  >
                    <div className="text-start">
                      <div className="mb-2">
                        {card.media_type === "image" && (
                          <div className="square-container">
                            <img
                              src={card.url_path}
                              className="border border-2 rounded-4 cursor-pointer"
                              alt={index}
                              onClick={() => openModal(card.url_path)}
                            />
                          </div>
                        )}
                        {card.media_type === "document" && (
                          <div className="square-container">
                            <div className="c-progress d-flex justify-content-center align-items-center border border-2 rounded-4">
                              <GrDocument size={40} />
                            </div>
                          </div>
                        )}
                        {card.media_type === "text" && (
                          <div className="square-container">
                            <div className="c-progress d-flex justify-content-center align-items-center border border-2 rounded-4">
                              <GrDocumentTxt size={40} />
                            </div>
                          </div>
                        )}
                        {card.media_type === "audio" && (
                          <div className="square-container">
                            <div className="c-progress d-flex justify-content-center align-items-center border border-2 rounded-4">
                              <GrDocumentSound size={40} />
                            </div>
                          </div>
                        )}
                        {card.media_type === "video" && (
                          <div className="square-container">
                            <div className="c-progress d-flex justify-content-center align-items-center border border-2 rounded-4">
                              <GrDocumentVideo size={40} />
                            </div>
                          </div>
                        )}
                      </div>
                      <div style={{ height: "36px" }}>
                        <h6 className="fs-12 fw-bold text-ellipsis-2-line">
                          {card.name}
                        </h6>
                      </div>
                    </div>
                    <hr className="m-0 mb-2" />
                    <p className="text-dark text-start fs-12 mb-0">
                      {formatFileSize(card.filesize)}
                    </p>
                    <p className="text-dark text-start fs-12 mb-0">
                      {card.media_type}/{card.extension}
                    </p>
                  </div>
                  <div className="d-flex">
                    <Dropdown
                      className="card-btn-dropdown"
                      style={{
                        position: "absolute",
                        top: "25px",
                        right: "25px",
                      }}
                    >
                      <Dropdown.Toggle
                        className="btn btn-ghost-primary-2 btn-icon btn-xs dropdown d-flex align-items-center justify-content-center"
                        style={{
                          width: "calc(0.4rem + 0.8em + 5px)",
                          borderRadius: "50%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <RiMore2Fill size={14} />
                        </span>
                      </Dropdown.Toggle>
                      <Dropdown.Menu style={{ marginTop: "28px" }} align="end">
                        <button
                          onClick={() => handleDownload(card.url_path)}
                          className="btn-md dropdown-item d-flex align-items-center"
                        >
                          <FaDownload size={12} className="me-2" />
                          Download
                        </button>
                        <button
                          onClick={() =>
                            handleDelete(card.fileid, card.filesize)
                          }
                          className="btn-md dropdown-item d-flex align-items-center"
                        >
                          <FaTrash size={12} className="me-2" />
                          Delete
                        </button>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="d-flex justify-content-center align-items-center my-2">
            <p className="fs-14">No Data</p>
          </div>
        )
      ) : (
        <div
          className="d-flex justify-content-center align-items-center my-2"
          style={{ minHeight: prevHeight }}
        >
          <Spinner animation="border" />
        </div>
      )}
      <ImagePopup isOpen={isOpen} imageUrl={imageUrl} closeModal={closeModal} />
    </>
  );
};

export default CardList;
